import {
  getCarts,
  postCart,
  patchCart,
  deleteCart,
} from "@/services/cart";
import {
  ProductType
} from "@/common/constant/ProductType";
import {
  getTodaysDate
} from "@/common/helpers/DateTimeHelper.js";
import {
  formatProcessingTime
 } from "@/common/helpers/ProductHelper";

const state = {
  carts: [],
};

const getters = {
  // order by cart id, backend API default response
  carts: (state) => state.carts,
  // order by cart product show_for_estore first
  cartsOderBySale: (state) => {
    return state.carts.sort((x, y) => y.product?.showForEstore - x.product?.showForEstore)
  },
  cartsCount: (state) => state.carts ? state.carts.filter((cart) => cart.product?.showForEstore == true).length : 0,
};

const actions = {
  async getCarts({ commit }) {
    try {
      const response = await getCarts();

      commit("getCarts", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async postCart({ dispatch, rootState }, payload) {
    const data = {
      productId: payload.productId,
      qty: 1,
      branchId: rootState.branches.selectedBranch.id,
    };

    try {
      const response = await postCart(data);

      // no need commit because no need to manipulate the state.carts, always refetch to make sure state.carts has latest and full nested data
      if (response.data) {
        await dispatch("getCarts");
      }
    } catch (error) {
      console.log(error);
    }
  },
  async patchCart({ dispatch, rootState }, payload) {
    const data = {
      id: payload.id, // cart id,
      qty: payload.qty, // cart qty
      branchId: rootState.branches.selectedBranch.id,
    }

    try {
      const response = await patchCart(data);

      // no need commit because no need to manipulate the state.carts, always refetch to make sure state.carts has latest and full nested data
      if (response.data) {
        await dispatch("getCarts");
      }
    } catch (error) {
      console.log(error);
    }
  },
  async deleteCart({ dispatch, rootState }, payload) {
    const data = {
      id: payload.id, // cart id
      branchId: rootState.branches.selectedBranch.id,
    };

    try {
      const response = await deleteCart(data);

      // no need commit because no need to manipulate the state.carts, always refetch to make sure state.carts has latest and full nested data
      if (response.data) {
        await dispatch("getCarts");
      }
    } catch (error) {
      console.log(error);
    }
  },
  resetCart({ commit }) {
    commit("resetCart", []);
  }
};

const mutations = {
  getCarts: (state, payload) => {
    const todaysDate = getTodaysDate();

    state.carts = payload.map((item) => {
      // format pricing for sale and promotion price
      let itemLine = null;

      const productType = item.product.type;
      let validPromotionQty = false;
      if (productType === ProductType.SERVICE) {
        itemLine = item.product.service;
        validPromotionQty = itemLine.limitQty === 0 || (itemLine.limitQty > 0 && itemLine.unitRemain > 0)

        item.product.service.formatProcessingTime = formatProcessingTime(item.product.type, itemLine.processingTime, '-');
      } else if (productType === ProductType.RETAIL_PRODUCT) {
        itemLine = item.product.retailProduct;
        validPromotionQty = itemLine.limitQty === 0 || (itemLine.limitQty > 0 && itemLine.unitRemain > 0)

        item.product.retailProduct.formatProcessingTime = formatProcessingTime(item.product.type, itemLine.processingTime, '-');
      } else if (productType === ProductType.COUPON) {
        itemLine = item.product.coupon;
        validPromotionQty = true; //coupon don't have limitQty and unitRemain (wess_coupon)

        item.product.coupon.formatProcessingTime = formatProcessingTime(item.product.type, itemLine.processingTime, '-');
      }

      if (
        itemLine.startDate <= todaysDate &&
        itemLine.endDate >= todaysDate &&
        validPromotionQty
      ) {
        item.product.promotion = true;
        item.product.salePrice = itemLine.promotionPrice;
        item.product.originalPrice = item.product.price;
      } else {
        item.product.promotion = false;
        item.product.salePrice = item.product.price;
        item.product.originalPrice = "";
      }

      item.product.promotionId = itemLine.promotionId;
      item.product.promotionPrice = itemLine.promotionPrice;
      item.product.promotionStartDate = itemLine.startDate;
      item.product.promotionEndDate = itemLine.endDate;

      return item;
    });
  },
  resetCart: (state, payload) => (state.carts = payload),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
